import './assets/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import i18n from './i18n';

import * as Sentry from '@sentry/vue';
import config from './config';

const app = createApp(App);
const pinia = createPinia();

Sentry.init({
  app,
  dsn: config.sentry.dsn,
  environment: config.environment,
  sendDefaultPii: true,
  enableLogs: true,
});

app.use(pinia);
app.use(i18n);
app.mount('#app');
